import { render } from "./TranslationModal.vue?vue&type=template&id=9f673f2a&ts=true"
import script from "./TranslationModal.vue?vue&type=script&lang=ts"
export * from "./TranslationModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__